
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ErrorBoundary } from 'react-error-boundary'
import './index.css'
import App from './App'

createRoot(document.getElementById('root')).render(
	<ErrorBoundary>
	    <App />
	</ErrorBoundary>
)
